/*
 * Copyright (c) 2017-2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _classCallCheck = require("/tank/jenkins/workspace/avis-admin_develop/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tank/jenkins/workspace/avis-admin_develop/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./util'),
    clone = _require.clone;

module.exports =
/*#__PURE__*/
function () {
  /**
   * Creates an active context cache.
   *
   * @param size the maximum size of the cache.
   */
  function ActiveContextCache() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

    _classCallCheck(this, ActiveContextCache);

    this.order = [];
    this.cache = new Map();
    this.size = size;
  }

  _createClass(ActiveContextCache, [{
    key: "get",
    value: function get(activeCtx, localCtx) {
      var level1 = this.cache.get(activeCtx);

      if (level1) {
        var key = JSON.stringify(localCtx);
        var result = level1.get(key);
        return result || null;
      }

      return null;
    }
  }, {
    key: "set",
    value: function set(activeCtx, localCtx, result) {
      if (this.order.length === this.size) {
        var entry = this.order.shift();
        this.cache.get(entry.activeCtx).delete(entry.localCtx);
      }

      var key = JSON.stringify(localCtx);
      this.order.push({
        activeCtx: activeCtx,
        localCtx: key
      });
      var level1 = this.cache.get(activeCtx);

      if (!level1) {
        level1 = new Map();
        this.cache.set(activeCtx, level1);
      }

      level1.set(key, clone(result));
    }
  }]);

  return ActiveContextCache;
}();